import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import ApplicantsPageSkeleton from "@/pages/_layouts/jobs/_components/ApplicantPageSkeleton";
import ViewJobPostReviews from "@/pages/_layouts/jobs/_components/ViewJobPostReviews";

export default function JobPostReviews() {
  const location = useLocation();
  const { data, loading, title } = useOutletContext<JobsOutletContext>();

  if (loading && !data?.jobPost) {
    return <ApplicantsPageSkeleton metricCards={2} />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Reviews`} />
      <ViewJobPostReviews jobPost={data.jobPost} />
    </>
  );
}
